<a [routerLink]="url" *ngIf="image" class="brand d-block">
  <img [src]="image" alt="logo" (error)="image = null">
</a>
